import React, {
  useEffect,
  useRef,
  useImperativeHandle,
  forwardRef,
} from "react";
import styled from "styled-components";
import { setPreventEvent } from "utils/event";
import ReactDOM from "react-dom";

export const Popup = forwardRef(
  (
    {
      open,
      onRender,
      padding,
      preventDefault = true,
      isRadius = true,
      ...props
    },
    ref
  ) => {
    const parentRef = useRef();
    const childRef = useRef();

    const eventHandler = {
      close: (event) => {
        if (event) setPreventEvent(event);
        if (parentRef.current) parentRef.current.classList.remove("focus");
        if (props.onClose) {
          setTimeout(() => {
            props.onClose(false);
          }, 300);
        }
      },
      preventEvent: (event) => {
        setPreventEvent(event, preventDefault);
      },
    };

    useImperativeHandle(ref, () => ({
      close: () => {
        eventHandler.close();
      },
    }));

    useEffect(() => {
      if (open && parentRef.current) {
        try {
          setTimeout(() => {
            parentRef.current.classList.add("focus");
            if (onRender) onRender(parentRef.current);
          }, 100);
        } catch (error) {
          console.log(error);
        }
      }
    }, [open]);

    return open
      ? ReactDOM.createPortal(
          <Wrapper
            ref={parentRef}
            visible={open}
            onClick={eventHandler.close}
            isRadius={isRadius}
            padding={padding}
          >
            <div
              ref={childRef}
              onClick={eventHandler.preventEvent}
              {...props}
            />
          </Wrapper>,
          document.body
        )
      : null;
  }
);

const Wrapper = styled.div`
  & {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 16;
    overflow: hidden;
    background-color: rgba(0, 0, 0, 0.4);
    visibility: hidden;
    opacity: 0;
    transition:
      visibility 0.25s,
      opacity 0.25s;
  }
  &.focus {
    visibility: visible;
    opacity: 1;
  }

  & > div {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    padding: ${(props) => (props.padding ? props.padding : "24px")};
    background-color: white;
    border-top-left-radius: ${(props) => (props.isRadius ? "15px" : "0")};
    border-top-right-radius: ${(props) => (props.isRadius ? "15px" : "0")};
    box-sizing: border-box;
    transform: translateY(100%);
    transition: transform 0.25s;
    overflow: hidden;
  }
  &.focus > div {
    transform: translateY(0);
  }

  & .top h3 {
    margin-bottom: 15px;
    line-height: 1;
    font-size: var(--18px);
  }
  & .bottom {
    margin-top: 15px;
  }
`;

export default Popup;
